import React from "react";
import Pickup from "../../../Models/Pickup";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../Store/Reducers";
import LoadingComponent from "../../Shared/LoadingComponent";
import {ModalActions} from "../../../Store/Modal/Slice";
import {SHIPPING_DETAIL_MODAL} from "../../../Store/Modal/Types";
import {getColumnStyle} from "../../../Utils/Utils";
import PickupCardComponent from "../ShipmentDashboard/PickupCardComponent";

const PendingShipmentComponent = () => {
  const {PickupReducer : {pPending}, LoadingReducer :{loadingPickups}} = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const openPendingShipmentDetail = (pendingShipment:Pickup) => {
    console.log(pendingShipment);
    dispatch(ModalActions.openModal({modal: SHIPPING_DETAIL_MODAL,data:{shippingInfo:pendingShipment}}));
  };

  return(
    <>
      <LoadingComponent loading={loadingPickups.status}/>
      {
        Boolean(pPending.length) &&
        pPending?.map((p: Pickup, index) => (
          <div key={`${index}_preview`} onClick={() => openPendingShipmentDetail(p)}>
            <PickupCardComponent columnStyle={getColumnStyle(p?.status)} pickup={p}/>
          </div>
        ))
      }
      { !loadingPickups.status.isLoading() && !Boolean(pPending.length) &&
          <div>
            No hay envios pendientes.
          </div>
      }
    </>
  );
};

export default PendingShipmentComponent;
